module.exports = __webpack_public_path__ + "img/img-programando.c079a076.png";